import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _3e269734 = () => interopDefault(import('../pages/accept-invitation.vue' /* webpackChunkName: "pages/accept-invitation" */))
const _392f5226 = () => interopDefault(import('../pages/blog/index.vue' /* webpackChunkName: "pages/blog/index" */))
const _3dacfc00 = () => interopDefault(import('../pages/change-password.vue' /* webpackChunkName: "pages/change-password" */))
const _c8c78b08 = () => interopDefault(import('../pages/dashboard.vue' /* webpackChunkName: "pages/dashboard" */))
const _724b6bc1 = () => interopDefault(import('../pages/days-off.vue' /* webpackChunkName: "pages/days-off" */))
const _237b9d3e = () => interopDefault(import('../pages/days-off-calculator.vue' /* webpackChunkName: "pages/days-off-calculator" */))
const _c9215c8c = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _356ab526 = () => interopDefault(import('../pages/forgot-password.vue' /* webpackChunkName: "pages/forgot-password" */))
const _5b8ea009 = () => interopDefault(import('../pages/help.vue' /* webpackChunkName: "pages/help" */))
const _6516f4d1 = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _ea4ea45c = () => interopDefault(import('../pages/logout.vue' /* webpackChunkName: "pages/logout" */))
const _4ee28642 = () => interopDefault(import('../pages/privacy-policy.vue' /* webpackChunkName: "pages/privacy-policy" */))
const _ff911ea4 = () => interopDefault(import('../pages/register/index.vue' /* webpackChunkName: "pages/register/index" */))
const _a4839542 = () => interopDefault(import('../pages/terms-of-use.vue' /* webpackChunkName: "pages/terms-of-use" */))
const _80391740 = () => interopDefault(import('../pages/company/administrators.vue' /* webpackChunkName: "pages/company/administrators" */))
const _55fb9e4a = () => interopDefault(import('../pages/company/employees.vue' /* webpackChunkName: "pages/company/employees" */))
const _6d32abce = () => interopDefault(import('../pages/company/export.vue' /* webpackChunkName: "pages/company/export" */))
const _a3913c24 = () => interopDefault(import('../pages/company/groups.vue' /* webpackChunkName: "pages/company/groups" */))
const _521f928d = () => interopDefault(import('../pages/company/non-working-days.vue' /* webpackChunkName: "pages/company/non-working-days" */))
const _7d1aac3d = () => interopDefault(import('../pages/company/settings.vue' /* webpackChunkName: "pages/company/settings" */))
const _20b135d9 = () => interopDefault(import('../pages/register/company.vue' /* webpackChunkName: "pages/register/company" */))
const _32818d1a = () => interopDefault(import('../pages/register/personal-information.vue' /* webpackChunkName: "pages/register/personal-information" */))
const _bba9509e = () => interopDefault(import('../pages/register/team.vue' /* webpackChunkName: "pages/register/team" */))
const _2cfd83ef = () => interopDefault(import('../pages/user/account-settings.vue' /* webpackChunkName: "pages/user/account-settings" */))
const _07ab4952 = () => interopDefault(import('../pages/user/approvers.vue' /* webpackChunkName: "pages/user/approvers" */))
const _579d8425 = () => interopDefault(import('../pages/user/days-off.vue' /* webpackChunkName: "pages/user/days-off" */))
const _d05b348e = () => interopDefault(import('../pages/user/employee-information.vue' /* webpackChunkName: "pages/user/employee-information" */))
const _480f6860 = () => interopDefault(import('../pages/user/export.vue' /* webpackChunkName: "pages/user/export" */))
const _50be89b4 = () => interopDefault(import('../pages/user/password-change.vue' /* webpackChunkName: "pages/user/password-change" */))
const _68c77d6a = () => interopDefault(import('../pages/user/personal-information.vue' /* webpackChunkName: "pages/user/personal-information" */))
const _b3f76928 = () => interopDefault(import('../pages/blog/_article.vue' /* webpackChunkName: "pages/blog/_article" */))
const _498bb3be = () => interopDefault(import('../pages/user/_id.vue' /* webpackChunkName: "pages/user/_id" */))
const _b95899b8 = () => interopDefault(import('../pages/user/_id/account-settings.vue' /* webpackChunkName: "pages/user/_id/account-settings" */))
const _a21ac886 = () => interopDefault(import('../pages/user/_id/approvers.vue' /* webpackChunkName: "pages/user/_id/approvers" */))
const _443cb85a = () => interopDefault(import('../pages/user/_id/days-off.vue' /* webpackChunkName: "pages/user/_id/days-off" */))
const _e7381b24 = () => interopDefault(import('../pages/user/_id/employee-information.vue' /* webpackChunkName: "pages/user/_id/employee-information" */))
const _702fb456 = () => interopDefault(import('../pages/user/_id/export.vue' /* webpackChunkName: "pages/user/_id/export" */))
const _ee455d5e = () => interopDefault(import('../pages/user/_id/password-change.vue' /* webpackChunkName: "pages/user/_id/password-change" */))
const _7fa46400 = () => interopDefault(import('../pages/user/_id/personal-information.vue' /* webpackChunkName: "pages/user/_id/personal-information" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/accept-invitation",
    component: _3e269734,
    name: "accept-invitation___hu___default"
  }, {
    path: "/blog",
    component: _392f5226,
    name: "blog___hu___default"
  }, {
    path: "/change-password",
    component: _3dacfc00,
    name: "change-password___hu___default"
  }, {
    path: "/dashboard",
    component: _c8c78b08,
    name: "dashboard___hu___default"
  }, {
    path: "/days-off",
    component: _724b6bc1,
    name: "days-off___hu___default"
  }, {
    path: "/days-off-calculator",
    component: _237b9d3e,
    name: "days-off-calculator___hu___default"
  }, {
    path: "/en",
    component: _c9215c8c,
    name: "index___en"
  }, {
    path: "/forgot-password",
    component: _356ab526,
    name: "forgot-password___hu___default"
  }, {
    path: "/help",
    component: _5b8ea009,
    name: "help___hu___default"
  }, {
    path: "/hu",
    component: _c9215c8c,
    name: "index___hu"
  }, {
    path: "/login",
    component: _6516f4d1,
    name: "login___hu___default"
  }, {
    path: "/logout",
    component: _ea4ea45c,
    name: "logout___hu___default"
  }, {
    path: "/privacy-policy",
    component: _4ee28642,
    name: "privacy-policy___hu___default"
  }, {
    path: "/register",
    component: _ff911ea4,
    name: "register___hu___default"
  }, {
    path: "/terms-of-use",
    component: _a4839542,
    name: "terms-of-use___hu___default"
  }, {
    path: "/company/administrators",
    component: _80391740,
    name: "company-administrators___hu___default"
  }, {
    path: "/company/employees",
    component: _55fb9e4a,
    name: "company-employees___hu___default"
  }, {
    path: "/company/export",
    component: _6d32abce,
    name: "company-export___hu___default"
  }, {
    path: "/company/groups",
    component: _a3913c24,
    name: "company-groups___hu___default"
  }, {
    path: "/company/non-working-days",
    component: _521f928d,
    name: "company-non-working-days___hu___default"
  }, {
    path: "/company/settings",
    component: _7d1aac3d,
    name: "company-settings___hu___default"
  }, {
    path: "/en/accept-invitation",
    component: _3e269734,
    name: "accept-invitation___en"
  }, {
    path: "/en/blog",
    component: _392f5226,
    name: "blog___en"
  }, {
    path: "/en/change-password",
    component: _3dacfc00,
    name: "change-password___en"
  }, {
    path: "/en/dashboard",
    component: _c8c78b08,
    name: "dashboard___en"
  }, {
    path: "/en/days-off",
    component: _724b6bc1,
    name: "days-off___en"
  }, {
    path: "/en/days-off-calculator",
    component: _237b9d3e,
    name: "days-off-calculator___en"
  }, {
    path: "/en/forgot-password",
    component: _356ab526,
    name: "forgot-password___en"
  }, {
    path: "/en/help",
    component: _5b8ea009,
    name: "help___en"
  }, {
    path: "/en/login",
    component: _6516f4d1,
    name: "login___en"
  }, {
    path: "/en/logout",
    component: _ea4ea45c,
    name: "logout___en"
  }, {
    path: "/en/privacy-policy",
    component: _4ee28642,
    name: "privacy-policy___en"
  }, {
    path: "/en/register",
    component: _ff911ea4,
    name: "register___en"
  }, {
    path: "/en/terms-of-use",
    component: _a4839542,
    name: "terms-of-use___en"
  }, {
    path: "/hu/accept-invitation",
    component: _3e269734,
    name: "accept-invitation___hu"
  }, {
    path: "/hu/blog",
    component: _392f5226,
    name: "blog___hu"
  }, {
    path: "/hu/change-password",
    component: _3dacfc00,
    name: "change-password___hu"
  }, {
    path: "/hu/dashboard",
    component: _c8c78b08,
    name: "dashboard___hu"
  }, {
    path: "/hu/days-off",
    component: _724b6bc1,
    name: "days-off___hu"
  }, {
    path: "/hu/days-off-calculator",
    component: _237b9d3e,
    name: "days-off-calculator___hu"
  }, {
    path: "/hu/forgot-password",
    component: _356ab526,
    name: "forgot-password___hu"
  }, {
    path: "/hu/help",
    component: _5b8ea009,
    name: "help___hu"
  }, {
    path: "/hu/login",
    component: _6516f4d1,
    name: "login___hu"
  }, {
    path: "/hu/logout",
    component: _ea4ea45c,
    name: "logout___hu"
  }, {
    path: "/hu/privacy-policy",
    component: _4ee28642,
    name: "privacy-policy___hu"
  }, {
    path: "/hu/register",
    component: _ff911ea4,
    name: "register___hu"
  }, {
    path: "/hu/terms-of-use",
    component: _a4839542,
    name: "terms-of-use___hu"
  }, {
    path: "/register/company",
    component: _20b135d9,
    name: "register-company___hu___default"
  }, {
    path: "/register/personal-information",
    component: _32818d1a,
    name: "register-personal-information___hu___default"
  }, {
    path: "/register/team",
    component: _bba9509e,
    name: "register-team___hu___default"
  }, {
    path: "/user/account-settings",
    component: _2cfd83ef,
    name: "user-account-settings___hu___default"
  }, {
    path: "/user/approvers",
    component: _07ab4952,
    name: "user-approvers___hu___default"
  }, {
    path: "/user/days-off",
    component: _579d8425,
    name: "user-days-off___hu___default"
  }, {
    path: "/user/employee-information",
    component: _d05b348e,
    name: "user-employee-information___hu___default"
  }, {
    path: "/user/export",
    component: _480f6860,
    name: "user-export___hu___default"
  }, {
    path: "/user/password-change",
    component: _50be89b4,
    name: "user-password-change___hu___default"
  }, {
    path: "/user/personal-information",
    component: _68c77d6a,
    name: "user-personal-information___hu___default"
  }, {
    path: "/en/company/administrators",
    component: _80391740,
    name: "company-administrators___en"
  }, {
    path: "/en/company/employees",
    component: _55fb9e4a,
    name: "company-employees___en"
  }, {
    path: "/en/company/export",
    component: _6d32abce,
    name: "company-export___en"
  }, {
    path: "/en/company/groups",
    component: _a3913c24,
    name: "company-groups___en"
  }, {
    path: "/en/company/non-working-days",
    component: _521f928d,
    name: "company-non-working-days___en"
  }, {
    path: "/en/company/settings",
    component: _7d1aac3d,
    name: "company-settings___en"
  }, {
    path: "/en/register/company",
    component: _20b135d9,
    name: "register-company___en"
  }, {
    path: "/en/register/personal-information",
    component: _32818d1a,
    name: "register-personal-information___en"
  }, {
    path: "/en/register/team",
    component: _bba9509e,
    name: "register-team___en"
  }, {
    path: "/en/user/account-settings",
    component: _2cfd83ef,
    name: "user-account-settings___en"
  }, {
    path: "/en/user/approvers",
    component: _07ab4952,
    name: "user-approvers___en"
  }, {
    path: "/en/user/days-off",
    component: _579d8425,
    name: "user-days-off___en"
  }, {
    path: "/en/user/employee-information",
    component: _d05b348e,
    name: "user-employee-information___en"
  }, {
    path: "/en/user/export",
    component: _480f6860,
    name: "user-export___en"
  }, {
    path: "/en/user/password-change",
    component: _50be89b4,
    name: "user-password-change___en"
  }, {
    path: "/en/user/personal-information",
    component: _68c77d6a,
    name: "user-personal-information___en"
  }, {
    path: "/hu/company/administrators",
    component: _80391740,
    name: "company-administrators___hu"
  }, {
    path: "/hu/company/employees",
    component: _55fb9e4a,
    name: "company-employees___hu"
  }, {
    path: "/hu/company/export",
    component: _6d32abce,
    name: "company-export___hu"
  }, {
    path: "/hu/company/groups",
    component: _a3913c24,
    name: "company-groups___hu"
  }, {
    path: "/hu/company/non-working-days",
    component: _521f928d,
    name: "company-non-working-days___hu"
  }, {
    path: "/hu/company/settings",
    component: _7d1aac3d,
    name: "company-settings___hu"
  }, {
    path: "/hu/register/company",
    component: _20b135d9,
    name: "register-company___hu"
  }, {
    path: "/hu/register/personal-information",
    component: _32818d1a,
    name: "register-personal-information___hu"
  }, {
    path: "/hu/register/team",
    component: _bba9509e,
    name: "register-team___hu"
  }, {
    path: "/hu/user/account-settings",
    component: _2cfd83ef,
    name: "user-account-settings___hu"
  }, {
    path: "/hu/user/approvers",
    component: _07ab4952,
    name: "user-approvers___hu"
  }, {
    path: "/hu/user/days-off",
    component: _579d8425,
    name: "user-days-off___hu"
  }, {
    path: "/hu/user/employee-information",
    component: _d05b348e,
    name: "user-employee-information___hu"
  }, {
    path: "/hu/user/export",
    component: _480f6860,
    name: "user-export___hu"
  }, {
    path: "/hu/user/password-change",
    component: _50be89b4,
    name: "user-password-change___hu"
  }, {
    path: "/hu/user/personal-information",
    component: _68c77d6a,
    name: "user-personal-information___hu"
  }, {
    path: "/en/blog/:article",
    component: _b3f76928,
    name: "blog-article___en"
  }, {
    path: "/en/user/:id?",
    component: _498bb3be,
    name: "user-id___en",
    children: [{
      path: "account-settings",
      component: _b95899b8,
      name: "user-id-account-settings___en"
    }, {
      path: "approvers",
      component: _a21ac886,
      name: "user-id-approvers___en"
    }, {
      path: "days-off",
      component: _443cb85a,
      name: "user-id-days-off___en"
    }, {
      path: "employee-information",
      component: _e7381b24,
      name: "user-id-employee-information___en"
    }, {
      path: "export",
      component: _702fb456,
      name: "user-id-export___en"
    }, {
      path: "password-change",
      component: _ee455d5e,
      name: "user-id-password-change___en"
    }, {
      path: "personal-information",
      component: _7fa46400,
      name: "user-id-personal-information___en"
    }]
  }, {
    path: "/hu/blog/:article",
    component: _b3f76928,
    name: "blog-article___hu"
  }, {
    path: "/hu/user/:id?",
    component: _498bb3be,
    name: "user-id___hu",
    children: [{
      path: "account-settings",
      component: _b95899b8,
      name: "user-id-account-settings___hu"
    }, {
      path: "approvers",
      component: _a21ac886,
      name: "user-id-approvers___hu"
    }, {
      path: "days-off",
      component: _443cb85a,
      name: "user-id-days-off___hu"
    }, {
      path: "employee-information",
      component: _e7381b24,
      name: "user-id-employee-information___hu"
    }, {
      path: "export",
      component: _702fb456,
      name: "user-id-export___hu"
    }, {
      path: "password-change",
      component: _ee455d5e,
      name: "user-id-password-change___hu"
    }, {
      path: "personal-information",
      component: _7fa46400,
      name: "user-id-personal-information___hu"
    }]
  }, {
    path: "/blog/:article",
    component: _b3f76928,
    name: "blog-article___hu___default"
  }, {
    path: "/user/:id?",
    component: _498bb3be,
    name: "user-id___hu___default",
    children: [{
      path: "account-settings",
      component: _b95899b8,
      name: "user-id-account-settings___hu___default"
    }, {
      path: "approvers",
      component: _a21ac886,
      name: "user-id-approvers___hu___default"
    }, {
      path: "days-off",
      component: _443cb85a,
      name: "user-id-days-off___hu___default"
    }, {
      path: "employee-information",
      component: _e7381b24,
      name: "user-id-employee-information___hu___default"
    }, {
      path: "export",
      component: _702fb456,
      name: "user-id-export___hu___default"
    }, {
      path: "password-change",
      component: _ee455d5e,
      name: "user-id-password-change___hu___default"
    }, {
      path: "personal-information",
      component: _7fa46400,
      name: "user-id-personal-information___hu___default"
    }]
  }, {
    path: "/",
    component: _c9215c8c,
    name: "index___hu___default"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
